import asparagusIcon from '@/assets/emoji-asparagus.png';
import beetrootIcon from '@/assets/emoji-beetroot.png';
import brusselsSproutsIcon from '@/assets/emoji-brussels-sprouts.png';
import cauliflowerIcon from '@/assets/emoji-cauliflower.png';
import celeriacIcon from '@/assets/emoji-celeriac.png';
import kohlrabiIcon from '@/assets/emoji-kohlrabi.png';
import parsnipIcon from '@/assets/emoji-parsnip.png';
import radishIcon from '@/assets/emoji-radish.png';
import squashIcon from '@/assets/emoji-squash.png';
import swissChardIcon from '@/assets/emoji-swiss-chard.png';
import turnipIcon from '@/assets/emoji-turnip.png';
import artichokeIcon from '@/assets/emoji-artichoke.png';
import leekIcon from '@/assets/emoji-leek.png';
import nasturtiumIcon from '@/assets/emoji-nasturtium.png';
import fennelIcon from '@/assets/emoji-fennel.png';
import blackberryIcon from '@/assets/emoji-blackberry.png';
import blackcurrantIcon from '@/assets/emoji-blackcurrant.png';
import figIcon from '@/assets/emoji-fig.png';
import gooseberryIcon from '@/assets/emoji-gooseberry.png';
import plumIcon from '@/assets/emoji-plum.png';
import raspberryIcon from '@/assets/emoji-raspberry.png';
import redcurrantIcon from '@/assets/emoji-redcurrant.png';

// Emoji icons mapped to plant names for visual flair
const PLANT_EMOJIS: Record<string, string> = {
  // Vegetables (only those with real matching emojis)
  'Aubergine': '🍆',
  'Broccoli': '🥦',
  'Cabbage': '🥬',
  'Carrots': '🥕',
  'Celery': '🥬',
  'Chillies': '🌶️',
  'Courgettes': '🥒',
  'Cucumber': '🥒',
  'French Beans': '🫛',
  'Garlic': '🧄',
  'Kale': '🥬',
  'Lettuce': '🥬',
  'Onions': '🧅',
  'Peas': '🫛',
  'Peppers': '🫑',
  'Potatoes': '🥔',
  'Pumpkins': '🎃',
  'Broad Beans': '🫘',
  'Runner Beans': '🫘',
  'Spinach': '🍃',
  'Sweetcorn': '🌽',
  'Tomatoes': '🍅',
  'Rocket': '🌿',
  // Herbs
  'Basil': '🌿',
  'Chives': '🌱',
  'Coriander': '🌿',
  'Dill': '🌿',
  'Mint': '🍃',
  'Oregano': '🌿',
  'Parsley': '🌿',
  'Rosemary': '🪴',
  'Sage': '🍃',
  'Thyme': '🌱',
  // Flowers
  'Calendula': '🌼',
  'Dahlia': '🌸',
  'Lavender': '💜',
  'Marigold': '🌺',
  'Marigolds': '🌺',
  'Strawberries': '🍓',
  'Strawberry': '🍓',
  'Sunflowers': '🌻',
  // Fruit
  'Apple Tree': '🍎',
  'Pear Tree': '🍐',
  'Sweet Peas': '🌸',
};

// Custom image icons for plants that don't have a good emoji match
const PLANT_IMAGES: Record<string, string> = {
  'Asparagus': asparagusIcon,
  'Beetroot': beetrootIcon,
  'Brussels Sprouts': brusselsSproutsIcon,
  'Cauliflower': cauliflowerIcon,
  'Celeriac': celeriacIcon,
  'Kohlrabi': kohlrabiIcon,
  'Parsnips': parsnipIcon,
  'Radishes': radishIcon,
  'Squash': squashIcon,
  'Swiss Chard': swissChardIcon,
  'Turnips': turnipIcon,
  'Globe Artichoke': artichokeIcon,
  'Globe Artichokes': artichokeIcon,
  'Artichoke': artichokeIcon,
  'Leeks': leekIcon,
  'Nasturtium': nasturtiumIcon,
  'Nasturtiums': nasturtiumIcon,
  'Florence Fennel': fennelIcon,
  'Fennel': fennelIcon,
  'Blackberries': blackberryIcon,
  'Blackcurrants': blackcurrantIcon,
  'Fig': figIcon,
  'Gooseberries': gooseberryIcon,
  'Plum Tree': plumIcon,
  'Raspberries': raspberryIcon,
  'Redcurrants': redcurrantIcon,
};

export function getPlantEmoji(name: string): string {
  return PLANT_EMOJIS[name] || '🌱';
}

export function getPlantImage(name: string): string | null {
  return PLANT_IMAGES[name] || null;
}
